export const css = {
	root: '_2llhV3gf',
	' _key': 'afcpe-theme/afcpe/backview/backview'
};

export default css;
